import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { View } from 'react-native';
import { ProgressBarView } from './ProgressBarView';
import { ProgressBarStepView } from './ProgressBarStepView';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
export const StepProgressBarView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.stepProgressBar,
    style: {
        container: {
            position: 'relative',
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center'
        },
        line: {
            zIndex: -1,
            position: 'absolute',
            left: 0,
            right: 0
        }
    }
})(({ style, model, values, onPress }) => {
    const [containerWidth, setContainerWidth] = useState(0);
    const handleContainerWidth = useCallback((e) => setContainerWidth(e.nativeEvent.layout.width), []);
    const indexOfActiveStep = values.findIndex(x => x.id === model);
    const iconSize = 19;
    const circleSize = 16;
    const circleMargin = 8;
    const lineHeight = 2;
    const centerPosition = iconSize + (((circleMargin * 2) + circleSize) / 2) - (lineHeight / 2);
    const numberOfItems = values.length <= 0
        ? 1
        : values.length;
    const step = containerWidth / numberOfItems;
    const halfStep = step / 2;
    const progressBarValue = (indexOfActiveStep + 1) * step - step;
    const startValue = 0;
    const endValue = containerWidth - step;
    return (_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.container, onLayout: handleContainerWidth, children: [_jsx(View, { style: { flex: 1, flexDirection: 'row' }, children: values.map((step, i) => {
                    return _jsx(ProgressBarStepView, { dimensions: {
                            iconSize,
                            circleSize,
                            circleMargin
                        }, value: step, isActive: i <= indexOfActiveStep, onPress: onPress }, step.id);
                }) }), _jsx(View, { style: [style === null || style === void 0 ? void 0 : style.line, { top: centerPosition, left: halfStep, right: halfStep }], children: _jsx(ProgressBarView, { startValue: startValue, endValue: endValue, value: progressBarValue, size: lineHeight }, endValue) })] }));
});
